// src/pages/mantenimiento/TabCostos.jsx
// 3.6 Costo de Mantenimiento por Departamento. Cada ticket puede tener
// VARIAS refacciones, cada una con su costo — se capturan en un modal
// con todo el contexto del ticket a la vista.
import { useEffect, useState, useRef } from 'react';
import Chart from 'chart.js/auto';
import api from '../../services/api';
import styles from './estilos';
import { FiltroFecha, primerDiaMesActual } from './componentes';

function TabCostos() {
  const [subTab, setSubTab] = useState('pendientes');
  return (
    <div>
      <p style={styles.subtitulo}>3.6 — Costo de Mantenimiento por Departamento.</p>
      <div style={{ display: 'flex', gap: 6, marginBottom: 14 }}>
        <button onClick={() => setSubTab('pendientes')} style={{ ...styles.subTabBtn, ...(subTab === 'pendientes' ? styles.subTabBtnActivo : {}) }}>Pendientes de Costo</button>
        <button onClick={() => setSubTab('resumen')} style={{ ...styles.subTabBtn, ...(subTab === 'resumen' ? styles.subTabBtnActivo : {}) }}>Resumen por Departamento</button>
      </div>
      {subTab === 'pendientes' ? <TabPendientes /> : <TabResumen />}
    </div>
  );
}

function TabPendientes() {
  const [pendientes, setPendientes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [ticketModal, setTicketModal] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/mantenimiento/costos/pendientes');
      setPendientes(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }
  useEffect(() => { cargar(); }, []);

  return (
    <div>
      {cargando ? <div>Cargando...</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead>
              <tr>
                <th style={styles.th}>Folio</th><th style={styles.th}>Departamento</th><th style={styles.th}>Equipo</th>
                <th style={styles.th}>Tipo</th><th style={styles.th}>Cerrado</th><th style={styles.th}></th>
              </tr>
            </thead>
            <tbody>
              {pendientes.map((p) => (
                <tr key={p.id}>
                  <td style={styles.td}>{p.folio_ticket_lista ? `#${p.folio_ticket_lista}` : '—'}</td>
                  <td style={styles.td}>{p.departamento || '—'}</td>
                  <td style={styles.td}>{p.equipo_descripcion}</td>
                  <td style={styles.td}>{p.tipo_mantenimiento}</td>
                  <td style={styles.td}>{new Date(p.hora_cierre).toLocaleDateString('es-MX')}</td>
                  <td style={styles.td}><button onClick={() => setTicketModal(p)} style={styles.botonBuscar2}>Capturar Costo</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          {pendientes.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>No hay tickets pendientes de costo. 🎉</p>}
        </div>
      )}

      {ticketModal && (
        <ModalCosto
          ticket={ticketModal}
          onCerrar={() => setTicketModal(null)}
          onGuardado={() => { setTicketModal(null); cargar(); }}
        />
      )}
    </div>
  );
}

function refaccionVacia() { return { nombre_refaccion: '', costo: '' }; }

function ModalCosto({ ticket, onCerrar, onGuardado }) {
  const [refacciones, setRefacciones] = useState([refaccionVacia()]);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  function actualizar(i, campo, valor) {
    setRefacciones((prev) => prev.map((r, idx) => (idx === i ? { ...r, [campo]: valor } : r)));
  }
  function agregar() { setRefacciones((prev) => [...prev, refaccionVacia()]); }
  function quitar(i) { setRefacciones((prev) => prev.filter((_, idx) => idx !== i)); }

  const total = refacciones.reduce((s, r) => s + (parseFloat(r.costo) || 0), 0);

  async function handleGuardar() {
    try {
      setGuardando(true);
      setMensaje(null);
      await api.post('/api/mantenimiento/costos', { ticket_id: ticket.id, refacciones });
      onGuardado();
    } catch (err) {
      console.error(err);
      setMensaje(err.response?.data?.error || 'No se pudo guardar.');
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div style={styles.modalFondo} onClick={onCerrar}>
      <div style={styles.modalCaja} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <div style={styles.modalTitulo}>Capturar Costo — Ticket {ticket.folio_ticket_lista ? `#${ticket.folio_ticket_lista}` : `#${ticket.id}`}</div>
          <button onClick={onCerrar} style={styles.modalCerrarBtn}>✕</button>
        </div>

        <div style={styles.modalContexto}>
          <div style={styles.modalContextoGrid}>
            <div><span style={styles.modalContextoLbl}>Equipo</span><br />{ticket.equipo_descripcion}</div>
            <div><span style={styles.modalContextoLbl}>Área</span><br />{ticket.equipo_area}</div>
            <div><span style={styles.modalContextoLbl}>Departamento</span><br />{ticket.departamento || '—'}</div>
            <div><span style={styles.modalContextoLbl}>Tipo</span><br />{ticket.tipo_mantenimiento}</div>
            <div><span style={styles.modalContextoLbl}>Zona</span><br />{ticket.zona_trabajo || '—'}</div>
            <div><span style={styles.modalContextoLbl}>Reportado</span><br />{new Date(ticket.hora_reporte).toLocaleString('es-MX')}</div>
            <div><span style={styles.modalContextoLbl}>Cerrado</span><br />{new Date(ticket.hora_cierre).toLocaleString('es-MX')}</div>
            <div><span style={styles.modalContextoLbl}>Duración</span><br />{parseFloat(ticket.horas_reparacion).toFixed(1)} hrs</div>
          </div>
          {ticket.descripcion_falla && <div style={styles.modalContextoTexto}><span style={styles.modalContextoLbl}>Falla:</span> {ticket.descripcion_falla}</div>}
          {ticket.descripcion_reparacion_final && <div style={styles.modalContextoTexto}><span style={styles.modalContextoLbl}>Reparación:</span> {ticket.descripcion_reparacion_final}</div>}
        </div>

        <div style={styles.modalSeccionTitulo}>Refacciones utilizadas</div>
        <div style={styles.tablaHead}>
          <span style={{ flex: 3 }}>Refacción</span>
          <span style={{ flex: 1 }}>Costo</span>
          <span style={{ width: 28 }} />
        </div>
        {refacciones.map((r, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'center' }}>
            <input type="text" placeholder="Ej. Balero 608" value={r.nombre_refaccion} onChange={(e) => actualizar(i, 'nombre_refaccion', e.target.value)} style={{ ...styles.input, flex: 3 }} />
            <input type="number" step="0.01" placeholder="$" value={r.costo} onChange={(e) => actualizar(i, 'costo', e.target.value)} style={{ ...styles.input, flex: 1 }} />
            {refacciones.length > 1 && <button onClick={() => quitar(i)} style={styles.botonQuitarFila}>✕</button>}
          </div>
        ))}
        <button onClick={agregar} style={styles.botonAgregarFila}>+ Agregar otra refacción</button>

        <div style={styles.modalTotal}>Total: <strong>${total.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</strong></div>

        {mensaje && <div style={{ ...styles.mensaje, color: '#B23A48' }}>{mensaje}</div>}

        <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
          <button onClick={onCerrar} style={styles.botonLimpiar}>Cancelar</button>
          <button onClick={handleGuardar} disabled={guardando} style={{ ...styles.botonGuardar, flex: 1 }}>
            {guardando ? 'Guardando...' : 'Guardar Costos'}
          </button>
        </div>
      </div>
    </div>
  );
}

function TabResumen() {
  const [datos, setDatos] = useState([]);
  const [costoTotal, setCostoTotal] = useState(0);
  const [cargando, setCargando] = useState(true);
  const [fDesde, setFDesde] = useState(primerDiaMesActual());
  const [fHasta, setFHasta] = useState(new Date().toISOString().slice(0, 10));
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/mantenimiento/costos/resumen', { params: { desde: fDesde, hasta: fHasta } });
      setDatos(res.data.data);
      setCostoTotal(res.data.costo_total_general);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }
  useEffect(() => { cargar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!canvasRef.current || datos.length === 0) return;
    if (chartRef.current) chartRef.current.destroy();
    chartRef.current = new Chart(canvasRef.current.getContext('2d'), {
      type: 'bar',
      data: {
        labels: datos.map((d) => d.departamento),
        datasets: [{
          label: 'Costo ($)',
          data: datos.map((d) => parseFloat(d.costo_total)),
          backgroundColor: '#6E4F80',
          borderRadius: 6,
        }],
      },
      options: {
        responsive: true, maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
          y: { beginAtZero: true, ticks: { callback: (v) => '$' + v.toLocaleString('es-MX') } },
          x: { ticks: { font: { size: 11 } } },
        },
      },
    });
    return () => { if (chartRef.current) chartRef.current.destroy(); };
  }, [datos]);

  return (
    <div>
      <div style={styles.kgrid}>
        <div style={styles.kcard}>
          <div style={styles.kLbl}>Costo Total de Mantenimiento</div>
          <div style={styles.kVal}>${costoTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</div>
          <div style={styles.kSub}>en el rango seleccionado</div>
        </div>
      </div>

      <div style={styles.filtrosBar}>
        <FiltroFecha label="Desde" value={fDesde} onChange={setFDesde} />
        <FiltroFecha label="Hasta" value={fHasta} onChange={setFHasta} />
        <button onClick={cargar} style={styles.botonBuscar2}>Buscar</button>
      </div>

      {datos.length > 0 && (
        <div style={{ ...styles.tarjeta, marginBottom: 14, height: 280 }}>
          <div style={styles.seccionTitulo}>Costo por Departamento</div>
          <div style={{ position: 'relative', height: 220 }}>
            <canvas ref={canvasRef} />
          </div>
        </div>
      )}

      {cargando ? <div>Cargando...</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead><tr><th style={styles.th}>Departamento</th><th style={styles.th}>No. Servicios</th><th style={styles.th}>Costo Total</th></tr></thead>
            <tbody>
              {datos.map((d) => (
                <tr key={d.departamento}>
                  <td style={styles.td}>{d.departamento}</td>
                  <td style={styles.td}>{d.num_servicios}</td>
                  <td style={{ ...styles.td, fontWeight: 700 }}>${parseFloat(d.costo_total).toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {datos.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin costos capturados en este rango.</p>}
        </div>
      )}
    </div>
  );
}

export default TabCostos;